import "./PixelCanvas.css";
import { useEffect } from "react";
import { MichelsonMap } from "@taquito/taquito";
import Sketch from "react-p5";
import { getStorage, setPixel } from "../utils/wallet";

import RefreshIcon from '@mui/icons-material/Refresh';
import Grid4x4Icon from '@mui/icons-material/Grid4x4';

import sndPop1 from "../sounds/pop1.mp3";
import sndPop2 from "../sounds/pop2.mp3";

export default function PixelCanvas(props) {

  let palette;

  let loaded = false;
  let loading = false;
  let size = 512;
  let pixelSize = 64;
  let x = -2;
  let y = -2;
  let color = -1;
  let pixels;
  let canRefresh = true;
  let theta = 0.0;
  let mouseDown = false;
  let showGrid = false;

  useEffect(() => {
    const interval = setInterval(() => {
      if(canRefresh){
        getStorage(drawStorage);
      }
    }, 20000);

    return () => clearInterval(interval);
  }, [])

  function refresh(){
    loading = true;
    if(canRefresh){
      getStorage(drawStorage);
      console.log("refreshed!");
    }
  }

  function clamp(_num, _min, _max){
    return Math.min(Math.max(_num, _min), _max);
  }

  function unlockButton(){
    var _btn = document.getElementById("setpixel");
    if(_btn.disabled && x >= 0 && y >= 0 && color >= 0){
      _btn.disabled = false;
      // Button Function
      _btn.addEventListener('click', () => {
        canRefresh = false;
        setPixel(color, x, y, function(){
          pixels.loadPixels();
          pixels.set(x,y,palette[color]);
          pixels.updatePixels();
          var _snd = new Audio(sndPop2);
          _snd.play();
          x = -2;
          y = -2;
          color = -1;
          _btn.disabled = true;
          // Disable colour buttons
          var _btns = document.getElementsByClassName("selectedColor");
          for(var i=0; i<_btns.length; i++){
            _btns[i].classList.remove("selectedColor");
          }
          console.log("sent!");
        },
        // Success
        () => {
          console.log("transaction sent!");
          window.location.reload(false);
        },
        // Failure
        () => {
          console.log("failed!");
          window.location.reload(false);
        });
      })
    }
  }

  function changeColor(col){
    var colBtns = document.getElementsByClassName("selectedColor");
    for(var i=0; i<colBtns.length; i++){
      colBtns[i].classList.remove("selectedColor");
    }
    var newBtn = document.getElementById("color" + col.toString());
    newBtn.classList.add("selectedColor");
    color = col;

    unlockButton();
  }

  function drawLoading(p5){
    theta += 0.2;
    p5.stroke(255);
    for(var i=-3; i<=3; i++){
      p5.strokeWeight(Math.max(Math.sin(theta)*2, 1)+Math.max(Math.sin(theta+i)*2, 1));
      var _lx = size/2 + 
      i*8;
      var _ly = size/1.8;
      var _am = Math.max(Math.sin(theta+i)*16, 4);
      p5.line(_lx, _ly-_am, _lx, _ly+_am);
    }
  }

  // Load pixels from storage
  const drawStorage = (storage) => {
    //console.log(storage);
    pixels.background(palette[storage.background]);
    pixels.loadPixels();
    var playSound = false;
    for(var i=0;i<pixelSize;i++){
      for(var j=0;j<pixelSize;j++){
        var _col = storage.canvas.get({0: i.toString(), 1: j.toString()});
        if(_col){
        //   if(!playSound){
        //     console.log(_col);
        //     var _ar = palette[_col.c[0]];
        //     var _ar2 = pixels.get(i,j).toString('#rrggbb');
        //     console.log(_ar);
        //     console.log(_ar2);
        //     if(_ar[0].replace( /^\D+/g, '') !== _ar2[0] || _ar[1] !== _ar2[1] || _ar[2] !== _ar2[2]){
        //       playSound = true;
        //     }
        //   }
          pixels.set(i,j,palette[_col]);
        }
      }
    }
    // Play sound
    // if(playSound){
    //   console.log("new pixels!");
    //   var _snd = new Audio(sndPop1);
    //   _snd.play();
    // }
    pixels.updatePixels();

    loaded = true;
    if(loading){
      var _snd = new Audio(sndPop1);
      _snd.play();
    }
    loading = false;
  }

  const setup = (p5, canvasParentRef) => {

    var cDiv = document.getElementById("canvas");
    size = cDiv.offsetWidth;

    palette = [
      p5.color('#000000'),
      p5.color('#1D2B53'),
      p5.color('#7E2553'),
      p5.color('#008751'),
      p5.color('#AB5236'),
      p5.color('#5F574F'),
      p5.color('#C2C3C7'),
      p5.color('#FFF1E8'),
      p5.color('#FF004D'),
      p5.color('#FFA300'),
      p5.color('#FFEC27'),
      p5.color('#00E436'),
      p5.color('#29ADFF'),
      p5.color('#83769C'),
      p5.color('#FF77A8'),
      p5.color('#FFCCAA')
    ]

    let cnv = p5.createCanvas(size,size).parent(canvasParentRef);
    cnv.mousePressed((event) => {
      mouseDown = true;
    });
    cnv.touchStarted((event) => {
      mouseDown = true;
    });
    cnv.mouseReleased((event) => {
      mouseDown = false;
      unlockButton();
      //console.log(x.toString() + ", " + y.toString());
    });
    cnv.touchEnded((event) => {
      mouseDown = false;
      unlockButton();
    });

    p5.background(0)
    p5.noSmooth();
    p5.noFill();

    pixels = p5.createGraphics(pixelSize,pixelSize);
    pixels.background(0);

    refresh();

  };

  const draw = (p5) => {

    // Get mouse pos
    if(canRefresh && !loading && mouseDown){
      x = Math.floor((p5.mouseX/size)*pixelSize);
      y = Math.floor((p5.mouseY/size)*pixelSize);
      x = clamp(x,0,pixelSize-1);
      y = clamp(y,0,pixelSize-1);
    }

    // If storage has been loaded
    if(loaded){
      var _gs = size/pixelSize;
      p5.image(pixels,0,0,size,size);

      // Draw grid
      if(showGrid){
        p5.strokeWeight(1);
        p5.stroke(0,0,0,100);
        for(var i=0; i<pixelSize; i++){
          p5.line(i*_gs,0,i*_gs,size);
          p5.line(0,i*_gs,size,i*_gs);
        }
      }

      // Draw selector
      if(color >= 0){
        p5.fill(palette[color]);
      }else{
        p5.noFill();
      }
      p5.stroke(0);
      p5.strokeWeight(2);
      p5.rect(_gs*x,_gs*y,_gs,_gs);
    }

    // If transaction is being applied on the chain
    if(!canRefresh){

      p5.strokeWeight(0);
      p5.fill(0, 0, 0, 127);
      p5.rect(0,0,size,size);
      p5.fill(255)
      p5.textAlign(p5.CENTER);
      p5.text('Confirming transaction...', size/2, size/2.2);

      drawLoading(p5);

      p5.strokeWeight(1);
    }else if(loading){

      p5.strokeWeight(0);
      p5.fill(0, 0, 0, 127);
      p5.rect(0,0,size,size);
      p5.fill(255)
      p5.textAlign(p5.CENTER);
      p5.text('Loading...', size/2, size/2.2);

      drawLoading(p5);
    }
  }

  const windowResized = (p5) => {
    var cDiv = document.getElementById("canvas");
    size = cDiv.offsetWidth;
    p5.resizeCanvas(size, size);
    p5.background(0);
  }

  return (
    <div id="canvas" className="pixel-canvas">
      <Sketch setup={setup} draw={draw} windowResized={windowResized} />
      
      <div className="pixel-controls">
        <button
        className="btn"
        id="btn-refresh"
        onClick={() => {
          canRefresh = true;
          refresh();
        }}><RefreshIcon />
        </button>

        <button
        className="btn"
        id="btn-grid"
        onClick={() => {
          showGrid = !showGrid;
        }}><Grid4x4Icon />
        </button>
      </div>

      <div className="set-pixel">

        <button
        className="btn"
        id="color0"
        onClick={() => {
          changeColor(0);
        }}></button>

        <button
        className="btn"
        id="color1"
        onClick={() => {
          changeColor(1);
        }}></button>

        <button
        className="btn"
        id="color2"
        onClick={() => {
          changeColor(2);
        }}></button>

        <button
        className="btn"
        id="color3"
        onClick={() => {
          changeColor(3);
        }}></button>

        <button
        className="btn"
        id="color4"
        onClick={() => {
          changeColor(4);
        }}></button>

        <button
        className="btn"
        id="color5"
        onClick={() => {
          changeColor(5);
        }}></button>

        <button
        className="btn"
        id="color6"
        onClick={() => {
          changeColor(6);
        }}></button>

        <button
        className="btn"
        id="color7"
        onClick={() => {
          changeColor(7);
        }}></button>

        <button
        className="btn"
        id="color8"
        onClick={() => {
          changeColor(8);
        }}></button>

        <button
        className="btn"
        id="color9"
        onClick={() => {
          changeColor(9);
        }}></button>

        <button
        className="btn"
        id="color10"
        onClick={() => {
          changeColor(10);
        }}></button>

        <button
        className="btn"
        id="color11"
        onClick={() => {
          changeColor(11);
        }}></button>

        <button
        className="btn"
        id="color12"
        onClick={() => {
          changeColor(12);
        }}></button>

        <button
        className="btn"
        id="color13"
        onClick={() => {
          changeColor(13);
        }}></button>

        <button
        className="btn"
        id="color14"
        onClick={() => {
          changeColor(14);
        }}></button>

        <button
        className="btn"
        id="color15"
        onClick={() => {
          changeColor(15);
        }}></button>

        <button
        id="setpixel"
        className=""
        disabled
        >
        Set Pixel
        </button>
      </div>

    </div>
  );
}

